/**
 * La forme de « Mon compte » pendant son premier chargement : la carte d'identité, les lignes de
 * progression, les statistiques et l'entrée vers les paramètres, dans les colonnes de la page.
 * Le cas montré est le cas courant : rien à finir, donc pas de bloc « À faire ».
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { columnStyles } from "../../atoms/containers/columns"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { SettingsSection, SettingsSectionSkeleton } from "../../molecules/SettingsSection"
import { ACCOUNT_AVATAR_SIZE } from "../../organisms/AccountIdentityCard"
import { ACTIVITY_STATS_TITLE, activityStatsStyles } from "../../organisms/ActivityStatsCard"

function IdentityBones() {
    return (
        <Card p="4">
            <Row gap="4" align="center">
                <Skeleton shape="circle" size={ACCOUNT_AVATAR_SIZE} />
                <Stack gap="2">
                    <Skeleton textSize="text-2xl" width={170} />
                    <Skeleton textSize="text-base" width={60} />
                    <Skeleton textSize="text-sm" width={150} />
                </Stack>
            </Row>
        </Card>
    )
}

/** La carte des statistiques : son intitulé, ses deux pilules de période, ses quatre tuiles. */
function StatisticsBones() {
    return (
        <SettingsSection title={ACTIVITY_STATS_TITLE}>
            <Stack gap="4">
                <View style={activityStatsStyles.periods}>
                    <Skeleton shape="block" width={110} height={pushButtonBoxHeight("sm")} radius="md" />
                    <Skeleton shape="block" width={170} height={pushButtonBoxHeight("sm")} radius="md" />
                </View>
                <View style={activityStatsStyles.grid}>
                    {[0, 1, 2, 3].map((index) => (
                        <Stack key={index} gap="1" style={activityStatsStyles.cell}>
                            <Skeleton textSize="text-2xl" width={56} />
                            <Skeleton textSize="text-sm" width={120} />
                        </Stack>
                    ))}
                </View>
            </Stack>
        </SettingsSection>
    )
}

export function StudentAccountSkeleton() {
    return (
        <View style={[columnStyles.columns, styles.fullWidth]}>
            <Stack gap="4" style={columnStyles.column}>
                <IdentityBones />
                <SettingsSectionSkeleton rows={4} />
            </Stack>
            <Stack gap="4" style={columnStyles.column}>
                <StatisticsBones />
                <SettingsSectionSkeleton rows={1} />
            </Stack>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    fullWidth: { width: "100%" },
}))
